module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/component/dialog/welcome-dialog/welcome-dialog.component.scss
// module id = G6S+
// module chunks = 1